import React, { Fragment } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    colors
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    fieldset: {
        minWidth: 950,
        maxWidth: 950
    }
}));


const Location = ({ item, closeEdition, updateValues, open }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="sm" >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Ponto de Instalação
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                name: Yup.string().max(50).required('Nome é obrigatório'),
                                plan: Yup.string().max(70).required('Descrição é o obrigatória'),
                                address: Yup.string().max(70).required('Endereço é obrigatório'),
                                neighborhood: Yup.string().max(50).required('Bairro é obrigatorio'),
                                city: Yup.string().max(50).required('Cidade é obrigatória'),
                                state: Yup.string().max(2).required('Estado é obrigatório'),
                                zipcode: Yup.string().max(50).required('CEP é obrigatorio')
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid
                                    container
                                    spacing={2}
                                >
                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.name && errors.name)}
                                            fullWidth
                                            label="Nome"
                                            margin="none"
                                            name="name"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.name}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.plan && errors.plan)}
                                            fullWidth
                                            label="Descrição"
                                            margin="none"
                                            name="plan"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.plan}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.address && errors.address)}
                                            fullWidth
                                            label="Endereço"
                                            margin="none"
                                            name="address"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.address}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.neighborhood && errors.neighborhood)}
                                            fullWidth
                                            label="Bairro"
                                            margin="none"
                                            name="neighborhood"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.neighborhood}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.city && errors.city)}
                                            fullWidth
                                            label="Cidade"
                                            margin="none"
                                            name="city"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.city}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.state && errors.state)}
                                            fullWidth
                                            label="Estado"
                                            margin="none"
                                            name="state"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.state}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.zipcode && errors.zipcode)}
                                            fullWidth
                                            label="CEP"
                                            margin="none"
                                            name="zipcode"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.zipcode}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.working && errors.working)}
                                            fullWidth
                                            label="Horário de Atendimento"
                                            margin="none"
                                            name="working"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.working}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.phone && errors.phone)}
                                            fullWidth
                                            label="Telefone"
                                            margin="none"
                                            name="phone"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.phone}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={4}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.lat && errors.lat)}
                                            fullWidth
                                            label="Latitude no GPS"
                                            margin="none"
                                            name="lat"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.lat}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={4}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.lon && errors.lon)}
                                            fullWidth
                                            label="Longitude no GPS"
                                            margin="none"
                                            name="lon"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.lon}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={4}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.position && errors.position)}
                                            fullWidth
                                            label="Posição Interna"
                                            margin="none"
                                            name="position"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.position}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                </Grid>
                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Location;
